import styled from "styled-components";

export const Container = styled.header`
    width: 100%;
    height: 72px;
    background-color: ${props => props.theme.colors.primary};
    box-shadow: 0px 0px 15px rgba(0,0,0,.3);
    display: flex;
    justify-content: center;
`;

export const LogoMini = styled.img`
    display: block;
    max-height: 33px;

    @media(min-width: 576px) {
        display: none;
    }
`;

export const LogoFull = styled.img`
    height: 100%;
    display: none;

    @media(min-width: 576px) {
        display: block;
    }
`;

export const Content = styled.div`
    display: flex;
    flex: 1;
    padding: 15px;
    max-width: 100%;
    align-items: center;
`;

export const ChildrenWrapper = styled.div`
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: flex-end;
`;

export const MenuToggle = styled.button`
    background-color: transparent;
    border: none;
    outline: none;
    cursor: pointer;
    width: 36px;
    height: 36px;
    margin-right: 15px;
`;

export const Dropdown = styled.ul `
    display: flex;
    padding: 0;
    margin: 0;
    list-style: none;
    height: 100%;
    
`;


export const DropdownItem = styled.li`

    display: flex;
    align-items: center;
    padding: 0 15px;
    min-height: 30px;
    height: 100%;
    padding-left: 20px;
    color: ${props => props.theme.textColor.primary};
    position: relative;;
    cursor: pointer;  
    box-sizing: border-box;
    
    &:hover {
        ol {
            transition: 1s all ease-in-out;
            display: flex;
        }
    }
`;

export const DropdownMenu = styled.ol`

    position: absolute;
    border-radius: 5px;
    right: 0;
    top: 100%;
    width: 200px;
    height: 100px;
    background-color: #fff;
    flex-direction: column;
    color: ${props => props.theme.textColor.primary};
    transition: 1s all ease-in-out;
    display: none;
    overflow: hidden;
    box-shadow: 0 0 5px rgba(0,0,0,0.5);
    
        a {
            display: flex;
            align-items: center;
            padding: 0 15px;
            min-height: 50px;
            color: ${props => props.theme.colors.primary};
            text-decoration: none;
        }
        
        a:hover {
            background-color: ${props => props.theme.colors.background};
            font-weight: bold;
        }

`;

